import React from 'react'
import { withRouter } from 'react-router-dom'
import { Socket } from 'phoenix-socket'

import { reportAutoSuggest } from '../../../common/analytics/searchBarAnalytics'
import autoSuggestEndpoint from '../../../common/constants/autoSuggestEndpoints'
import AutoSuggest from '../autosuggest/'
import { makeLink, parseLocation } from '../../../common/utils/urlHelper'

class SearchBarInputComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      suggestions: [],
      term: props.value || '',
      socketChannel: null,
      socketConnection: null
    }

    this.setSuggestions = this.setSuggestions.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.onSelectOption = this.onSelectOption.bind(this)
  }

  componentDidMount () {
    this.initSocket()
  }

  componentWillUnmount () {
    this.closeSocket()
  }

  initSocket () {
    const { endpoint, channel } = autoSuggestEndpoint

    const socketConnection = new Socket(endpoint)
    const socketChannel = socketConnection.channel(channel, {})

    this.setState({
      socketChannel,
      socketConnection
    })

    socketConnection.connect()

    socketChannel.on('phx_reply', (payload) => {
      if (payload.status === 'error') {
        console.log('connection to auto suggest service error', payload)
      }
    })

    socketChannel.on('new_msg', (message) => {
      this.setSuggestions(message.body)
    })

    socketChannel
      .join()
      .receive('ok', () => {
        if (this.state.term) {
          this.sendMessage(this.state.term)
        }
      })
  }

  closeSocket () {
    if (this.state.socketConnection) {
      this.state.socketConnection.disconnect()
    }
  }

  sendMessage (value = '') {
    const { currentSite } = this.props
    const { socketChannel } = this.state

    const message = {
      body: value.trim().toLowerCase(),
      category: null,
      site: currentSite || 'themeforest'
    }

    if (socketChannel && socketChannel.state === 'joined') {
      socketChannel.push('new_msg', message)
    }
  }

  setSuggestions (suggestions) {
    this.setState({
      suggestions
    })
  }

  onInputChange (value = '') {
    this.setState({
      term: value
    })
    this.sendMessage(value)
  }

  onSelectOption (option, event) {
    const { location, history } = this.props
    const { suggestions } = this.state

    // if the selection option is a string, we need to build the link

    if (typeof option === 'string') {
      let nextQueries = Object.assign({},
        parseLocation(location),
        {term: option})

      // reset page number when change search term
      delete nextQueries.page

      const link = makeLink(nextQueries)
      option = {
        text: option,
        link
      }
    // if the selection option is an object, it means it's triggered by auto-suggest
    // we need to report this to ga
    } else if (typeof option === 'object') {
      reportAutoSuggest({
        action: event && event.type === 'mousedown' ? 'click' : 'keyboard',
        label: option.text,
        suggestedTerm: suggestions.map((suggestion) => {
          return suggestion.text
        })
      })
    }

    this.setState({
      term: option.text
    }, () => {
      history.push(option.link)
    })
  }

  render () {
    const { suggestions, term } = this.state
    const { name } = this.props
    return (
      <AutoSuggest
        suggestions={suggestions}
        onInputChange={this.onInputChange}
        placeholder={'Search within these results'}
        onSelectOption={this.onSelectOption}
        inputName={name}
        inputValue={term}
        type={'search'}
      />
    )
  }
}

export default withRouter(SearchBarInputComponent)



// WEBPACK FOOTER //
// ./client/components/searchBar/searchBarAutoSuggest.js